import React, { useEffect, useState } from 'react';
import { Table, Button, Spin, Input, Row, Col, message, Modal } from 'antd';
import apiRequest from '../hooks/ApiRequest';
import Layouts from '../components/Layouts';

const BrokerPoliciesReport = () => {
    const [reportData, setReportData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState('');

    // Modal state
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [brokerPolicies, setBrokerPolicies] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);

    useEffect(() => {
        fetchBrokerPoliciesReport();
    }, []);

    const fetchBrokerPoliciesReport = async () => {
        setLoading(true);
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            const insurerId = user?.UserId;
            if (!insurerId) {
                message.error("Insurer ID not found in user data");
                setLoading(false);
                return;
            }

            const apiUrl = `${process.env.REACT_APP_BASE_URL}/Policy/GetBrokerReportPolicies/BrokerReportPolicies/${insurerId}`;
            const res = await apiRequest(apiUrl, 'GET');
            const data = Array.isArray(res) ? res : res?.data || [];
            setReportData(data);
            setFilteredData(data);
        } catch (error) {
            console.error('Error fetching broker policies report:', error);
            setReportData([]);
            setFilteredData([]);
        } finally {
            setLoading(false);
        }
    };

    const viewPolicies = async (broker) => {
        setSelectedBroker(broker);
        setIsModalOpen(true);  // open modal immediately
        setModalLoading(true);

        try {
            const apiUrl = `${process.env.REACT_APP_BASE_URL}/Policy/GetBrokerPoliciesByBrokerId/${broker.brokerId}`;
            const res = await apiRequest(apiUrl, 'GET');
            const policies = Array.isArray(res) ? res : res?.data || [];
            setBrokerPolicies(policies);
        } catch (err) {
            console.error(err);
            message.error("Failed to fetch broker policies.");
            setBrokerPolicies([]);
        } finally {
            setModalLoading(false);
        }
    };

    const handleFilter = () => {
        const search = searchText.toLowerCase();
        const filtered = reportData.filter((item) =>
            item.brokerName?.toLowerCase().includes(search)
        );
        setFilteredData(filtered);
    };

    const clearFilters = () => {
        setSearchText('');
        setFilteredData(reportData);
    };

    const columns = [
        { key: 'brokerName', title: 'Broker Name', dataIndex: 'brokerName' },
        { key: 'totalPolicies', title: 'Total Policies', dataIndex: 'totalPolicies' },
        { key: 'premiumCollected', title: 'Premium Collected', dataIndex: 'premiumCollected' },
        {
            key: 'view',
            title: 'View Policies',
            render: (_, record) => (
                <Button
                    type="primary"
                    style={{ backgroundColor: '#0d6efd', borderColor: '#0d6efd' }}
                    onClick={() => viewPolicies(record)}
                >
                    View
                </Button>
            ),
        },
    ];

    const policyColumns = [
        { key: 'policyNumber', title: 'Policy Number', dataIndex: 'policyNumber' },
        { key: 'startDate', title: 'Start Date', dataIndex: 'startDate' },
        { key: 'endDate', title: 'End Date', dataIndex: 'endDate' },
        { key: 'premium', title: 'Premium', dataIndex: 'premium' },
        { key: 'status', title: 'Status', dataIndex: 'status' },
        {
            key: 'actions',
            title: 'Actions',
            render: (record) => (
                <Button
                    type="link"
                    onClick={() => {
                        window.location.href = '/policies';
                    }}
                >
                    View Details
                </Button>
            ),
        },
    ];


    return (
        <Layouts title="Broker Policies Report" classname="dashboard">
            <Spin spinning={loading} size="large" className="loader-icon-fixed" />

            <div className="dash-bg-white">
                <Row gutter={[16, 16]}>
                    <Col xs={12} sm={24} md={24} lg={12}>
                        <div className="section-top-heading">
                            <h3 style={{ color: '#0C1362', fontWeight: 600, fontSize: '20px' }}>
                                Broker Policies Report
                            </h3>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className="dash-bg-white m-b-20">
                <Row gutter={[24, 24]}>
                    <Col xs={24} sm={12} md={18} lg={20} className="custom-statcards">
                        <Input
                            placeholder="Search Broker Name"
                            value={searchText}
                            onChange={(e) => {
                                setSearchText(e.target.value);
                                handleFilter();
                            }}
                            style={{ width: 300 }}
                        />
                        &nbsp;&nbsp;
                        <Button type="primary" onClick={handleFilter}>
                            Search
                        </Button>
                        &nbsp;
                        <Button onClick={clearFilters}>Clear</Button>
                    </Col>
                </Row>
            </div>

            <div className="table-grid-bx">
                <Table
                    columns={columns}
                    dataSource={filteredData}
                    loading={loading}
                    rowKey="brokerId"
                    pagination={{ pageSize: 10 }}
                />
            </div>

            {/* Modal for Policies */}
            <Modal
                title={`Policies for ${selectedBroker?.brokerName || ''}`}
                visible={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width={900}
            >
                <Spin spinning={modalLoading}>
                    <Table
                        columns={policyColumns}
                        dataSource={brokerPolicies}
                        rowKey="policyNumber"
                        pagination={{ pageSize: 5 }}
                    />
                </Spin>
            </Modal>

        </Layouts>
    );
};

export default BrokerPoliciesReport;
